import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogPaintCutType } from "../models/CatalogPaintCutType";

export const getCatalogPaintCutTypes = async (): Promise<
	CatalogPaintCutType[]
> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[FAB].[GetPaintCutTypes]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogPaintCutType[];
	}
	throw new Error(resp.message || "Error fetching catalog paint cut types");
};

export const upsertCatalogPaintCutType = async (
	paintCutType: CatalogPaintCutType,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "PaintCutTypeId", value: paintCutType.PaintCutTypeId },
		{ name: "PaintCutTypeName", value: paintCutType.PaintCutTypeName },
		{ name: "Enabled", value: paintCutType.IsActive },
	];
	return await apiService.callV2("[FAB].[UpsertPaintCutType]", parameters);
};

export const deleteCatalogPaintCutType = async (paintCutTypeId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "PaintCutTypeId", value: paintCutTypeId },
	];
	return await apiService.callV2("[FAB].[DeletePaintCutType]", parameters);
};
